var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex justify-content-end w-100 container-geral-settings"},[_c('div',{staticClass:"mt-5",staticStyle:{"width":"90%"}},[_c('Company')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }